module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0054.jpg?v=9327a276";